"use client";

/**
 * 첫 페인트 전에 돌아야 하는 인라인 스크립트(<head> 안).
 *
 * 서버 HTML 의 <script> 는 브라우저가 파싱하며 바로 실행한다. 그런데 루트 레이아웃이
 * 클라이언트에서 다시 그려지면(언어 전환 = [locale] 바뀜) React 19 가 새 <script> 를 만들며
 * "Encountered a script tag…" 콘솔 에러를 낸다(어차피 실행되지 않는 태그).
 * 클라이언트에서는 type 을 데이터 블록으로 바꿔 경고를 피한다 — 실행 시점(서버 HTML)은 그대로.
 * next/script beforeInteractive 는 Next 런타임 로드 뒤에 실행돼 첫 페인트 전 보장이 없어 쓰지 않는다.
 */
export function InlineBootScript({ html }: { html: string }) {
  return (
    <script
      type={typeof window === "undefined" ? undefined : "text/plain"}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
